import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import ApiService from "../../../functions/apiService";
import { toast } from 'react-toastify';

export default function ResetEmail() {
  // const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  let columns = [
    {
      field: "Emp_Code",
      headerName: "ID",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "fullName",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params.row.EA_Rank + " " + params.row.fullName,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  const onSubmit = () => {
    setLoading(true);
    ApiService.post("/employeeResetEmail", [])
      .then(({ data }) => {
        setLoading(false);
        console.log("data", data);
        setModalData(data);
        setOpen(true);
        toast.success('Reset Successfully')
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };
  let closeModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        Email
      </Typography>

      <div className="col-12 mt-2">
        <ButtonTheme disabled={loading} onClick={onSubmit} color="primary">
          Reset Email
        </ButtonTheme>
      </div>
      <ConfModal Title="Employees" open={open} closeModal={closeModal}>
        {modalData && modalData.message && (
          <p class="h4 my-2">{modalData.message}</p>
        )}
        <h2>
          Deleted Email ({modalData.deleted ? modalData.deleted.length : 0})
        </h2>
        {modalData && modalData.deleted && modalData.deleted.length > 0 && (
          <div>
            <MyTable
              rows={modalData.deleted}
              columns={columns}
              useTopFilter={false}
              checkboxSelection={false}
              hideFooter={true}
            />
          </div>
        )}
        <h2>
          Updated Email ({modalData.updated ? modalData.updated.length : 0})
        </h2>
        {modalData && modalData.updated && modalData.updated.length > 0 && (
          <div>
            <MyTable
              rows={modalData.updated}
              columns={columns}
              useTopFilter={false}
              checkboxSelection={false}
              hideFooter={true}
            />
          </div>
        )}
      </ConfModal>
    </>
  );
}
